/**
 * Created by dreamc_t on 2017/5/23.
 */
import './adTop.scss';
import tmpl from './adTop.ejs';
import Events from 'f.core.event';

class AdTop {
    constructor(options, adCount) {
        this.adCount = adCount;
        this.options = options;
        this.init();
    }

    init() {
        this.formatData();
        this.initDom();
        this.initEvent();
        this.sendCount(this.pvurl);
    }

    initDom() {
        let parentNode = document.querySelector('.p-wrap');
        let relNode = document.querySelector('.l-head');
        let _tmp = tmpl({
            adPositionId: this.adPositionId,
            text: this.text,
            image: this.image,
            showIcon: this.showIcon,
            height: this.height,
        });
        this.el = $(_tmp);
        parentNode.insertBefore(this.el[0], relNode);
    }

    initEvent() {
        // let _this = this;
        this.el.on('touchend', () => {
            this.sendStatToApp('click');
            this.trigger('top_ad', this.url);
        });
        this.timer = null;
        this.timer = setTimeout(() => {
            this.el.slideUp(500, () => {
                this.trigger('toggle');
            });
        }, this.duration * 1000);
        console.log(`顶通倒计时=====>${this.duration}`)
    }

    sendCount(urlArr) {
        urlArr.map(item => {
            let image = new Image();
            image.src = item;
        });
    }

    // '#adinfo#ainfo=10018600:100186003610:piclive_104314$first=yes'

    sendStatToApp(type) {
        if (type == 'click') {
            let loc = this.adPositionId;
            let id = this.adId;
            this.trigger('adclick', { loc, id });
        } else {
            let ainfo = this.adPositionId + ':' + this.adId;
            this.trigger('adinfo', { ainfo });
        }
    }

    formatData() {
        this.adPositionId = this.options.adPositionId;
        this.pvurl = this.options.adMaterials[0].adAction.pvurl;
        this.async_click = this.options.adMaterials[0].adAction.async_click;
        this.url = this.options.adMaterials[0].adAction.url;
        this.image = this.options.adMaterials[0].imageURL;
        this.duration = this.options.adMaterials[0].duration || this.adCount;
        this.showIcon = this.options.adMaterials[0].icon.showIcon;
        this.height = this.options.adMaterials[0].imageHeight;
        this.adId = this.options.adMaterials[0].adId;
    }
}

Events.mixTo(AdTop);

export default AdTop;



// WEBPACK FOOTER //
// ./app/modules/adTop/index.js